const o = {
  name: "ThumbDown",
  dimensions: { width: 24, height: 24 },
  content: `
        <g fill="none" stroke="currentColor">
            <path d="M19.0059 12.5L19.0059 1.5L5.24586 1.5C4.48586 1.5 3.78586 1.93 3.45586 2.61L1.36586 6.84C0.155861 9.49 2.09586 12.5 5.00586 12.5L8.00586 12.5L7.47586 13.42C5.93586 16.13 7.88586 19.5 11.0059 19.5L13.4864 13.7122C13.8015 12.9768 14.5246 12.5 15.3247 12.5L19.0059 12.5Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
            <path d="M15.0059 12.5L15.0059 1.5" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
        </g>
    `
};
export {
  o as ThumbDown
};
